import { Typography } from '@/components/ui/typography'
import type { SalesOrderListItem } from '@/lib/services/sales-orders/sales-orders.types'
import { formatCurrency } from '@/lib/utils'
import {
  getSalesOrderRemainingTotal,
  shouldShowSalesOrderBalanceDue,
} from './sales-order-presentation'

type AmountFields = Pick<
  SalesOrderListItem,
  'financial_state' | 'order_source_link' | 'cancelled_at' | 'refund_status' | 'payment_status'
>

/** An order row's Total (the Order total, shop fee included) and the balance still to collect, as the API states them. */
export function SalesOrderAmountCell({ order }: { order: AmountFields }) {
  return (
    <>
      <span className="font-semibold tabular-nums">
        {formatCurrency(order.financial_state.order_total)}
      </span>
      {shouldShowSalesOrderBalanceDue(order) ? (
        <Typography variant="caption" tone="warning" weight="normal" className="mt-1 block">
          Balance due {formatCurrency(getSalesOrderRemainingTotal(order))}
        </Typography>
      ) : null}
    </>
  )
}
